import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

type LogoMarhubProps = {
  width?: number;
  height?: number;
  to?: string;
};

const LOGO_SRC = {
  en: "/logo-marhub-en.svg",
  ar: "/logo-marhub-ar.svg",
} as const;

const LogoMarhub: React.FC<LogoMarhubProps> = ({ width, height = 60, to = "/" }) => {
  const { t, i18n } = useTranslation();

  const lang = (i18n.resolvedLanguage ?? i18n.language ?? "en").toLowerCase();
  const isArabic = lang.startsWith("ar");

  const style: React.CSSProperties = {
    height: `${height}px`,
    ...(width ? { width: `${width}px` } : {}),
  };

  return (
    <Link to={to} className="flex items-center">
      <img
        src={isArabic ? LOGO_SRC.ar : LOGO_SRC.en}
        alt={t("licensing.marhub-logo-alt")}
        className="w-auto"
        style={style}
        data-testid="logo-marhub"
      />
    </Link>
  );
};

export default LogoMarhub;
